import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2505 11.1541C12.5727 11.1541 12.8338 11.4153 12.8338 11.7375C12.8338 12.0366 12.6086 12.2832 12.3185 12.3169L12.2505 12.3208H7.00049C6.67832 12.3208 6.41716 12.0596 6.41716 11.7375C6.41716 11.4383 6.64235 11.1918 6.93246 11.1581L7.00049 11.1541H12.2505ZM9.21301 1.69999C9.67298 1.24002 10.3434 1.06038 10.9717 1.22874C11.6001 1.3971 12.0909 1.88788 12.2592 2.51622C12.4276 3.14455 12.2479 3.81498 11.788 4.27495L4.4963 11.5666C4.42154 11.6414 4.32787 11.6944 4.2253 11.7201L1.89197 12.3034C1.46475 12.4102 1.07777 12.0232 1.18457 11.596L1.76791 9.26266C1.79355 9.16009 1.84659 9.06641 1.92134 8.99166L9.21301 1.69999ZM10.5941 2.34009C10.3915 2.31075 10.1849 2.37806 10.038 2.52495L2.86057 9.70222L2.55199 10.9354L3.78516 10.6268L10.963 3.44999C11.1099 3.30311 11.1772 3.09649 11.1479 2.89385L11.1323 2.81817C11.0718 2.59245 10.8955 2.41614 10.6698 2.35565L10.5941 2.34009Z"
        fill="#DF692B"
      />
    </Svg>
  );
};

export default Icon;
